import type { ExpoOrder } from '../types';
import EmptyState from '../EmptyState';
import BoardGrid from './BoardGrid';
import ExpoOrderCard from './ExpoOrderCard';

type Props = {
  orders: ExpoOrder[];
  stationNameById: Map<number, string>;
  selectedGroupId: string | null;
  focusedCardId: string | null;
  onOpenDetail: (groupId: string) => void;
};

const ExpoBoard = ({ orders, stationNameById, selectedGroupId, focusedCardId, onOpenDetail }: Props) => {
  if (orders.length === 0) return <EmptyState label="Expo" />;

  return (
    <BoardGrid>
      {orders.map((order) => (
        <ExpoOrderCard
          key={order.groupId}
          order={order}
          stationNameById={stationNameById}
          selected={order.groupId === selectedGroupId}
          focused={order.groupId === focusedCardId}
          onOpen={() => onOpenDetail(order.groupId)}
        />
      ))}
    </BoardGrid>
  );
};

export default ExpoBoard;
